import { render, staticRenderFns } from "./AddToBasketButton.vue?vue&type=template&id=287098e2&"
import script from "./AddToBasketButton.vue?vue&type=script&lang=js&"
export * from "./AddToBasketButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports